// hooks/useCopyOverlay.js
import { useCallback, useEffect, useRef, useState } from 'react';
import { copyText } from '../utils/copyText';

export function useCopyOverlay() {
    const btnRef = useRef(null);
    const [count, setCount] = useState(0);
    const [show, setShow] = useState(false);
    const timerRef = useRef(null);

    const copyArray = useCallback(async arr => {
        if (!arr?.length) return;
        await copyText(arr.join('\n'));
        setCount(arr.length);
        setShow(true);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setShow(false), 1300);
    }, []);

    useEffect(
        () => () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        },
        []
    );

    return { btnRef, count, show, copyArray };
}
